// src/utils/authUtils.js
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';

export const signIn = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential;
};